import { useLingui } from "@lingui/react/macro";

interface MayflowerMarkProps {
  size?: number;
  className?: string;
}

/**
 * Compact Mayflower mark (orange leaf only) — used as the brand glyph in
 * the sidebar header. Mirrors `voicebot-ui-redesign/.../mayflower-mark.svg`.
 */
export function MayflowerMark({
  size = 24,
  className,
}: Readonly<MayflowerMarkProps>) {
  const { t } = useLingui();
  return (
    <svg
      width={size}
      height={size}
      viewBox="60 0 95 87"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t`Mayflower mark`}
      className={className}
    >
      <path
        fill="#e75300"
        d="M176.32,28.43c1.76-1.49,4.25-.08,5.19,1.4s2.59,16.6,3.07,19.68c2.62,16.78,11.17,28.08,11.17,30.43,0,3.39-2.47,4.74-4.92,5.57,0,0-3.75,1.18-5.57,0-3-1.93-6.63-10.17-8.22-12.75-4-6.48-5.48-23.34-8.38-23.65-2.34-.26-32.23,42.73-31.48,45.29.54,2.57,3.23,2.54,4,2.64,8.1,1.07,23.77-2.68,25.3-3,5-1.1,16.07,0,16.07,0,2.66.27,7.09,2,6.92,5.14-.16,2.92-4.89,6.61-6.91,5.58a8.56,8.56,0,0,0-6-.63c-1.88,0-8.58,4.06-13.66,8.07-2.77,2.19-11.76,2.39-13.71,2.14-3.12-.4-12-5.23-15.52-7.5-1.55-1-11.64-9.13-13.81-12.85,0,0-3.65-6-4.28-8.13s.06-6.28,1-6.64c24-9.43,58.36-49.54,59.81-50.77Z"
        transform="translate(-43.71 -27.79)"
      />
    </svg>
  );
}
